/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-28T08:21:10.685Z by lizhutang (lizhutang@spolo.org)

'use strict'

import htmlTPL from './htmltpl.txt'
import handlers from './handler'

function outerHtml ($ele) {
  return $ele.html()
}

function dumpGrapeOBJ (grapeOBJ) {
  let css = grapeOBJ['gjs-css'] || ''
  let html = grapeOBJ['gjs-html'] || ''
  return `${css ? `<style>${css}</style>` : ''}${html}`
}
/**
返回本扩展库的版本号。
@method build
@param {array|object} params
1. content|0 {string|object}: 字符串或webeditor元素保存的JSON对象，其内容为需要编译的html内容。
2. opts|1 {object}: 配置项。（可选)
3. css|2 {string}: 加在head末尾的css。（可选)
4. js|3 {string}: 加在head末尾的JS。（可选)
@param {Element} [refEle=undefined] 调用命令时的索引Dom Element。
@param {Event} [evt=undefined] 调用命令时的索引事件对象。
@return {Promise<object>} 返回编译结果对象,格式为:
- content {string}: 字符串，包含了完整的HTML文档内容.
- dep {array<string>}: 依赖的项目中页面地址.
- error {string|undefined}: 如果有错误，则error为错误描述。
*/
function build (params, refEle, evt) {
  let para = wwjs.net.extract(params, ['content', 'opts', 'css', 'js']) || {}
  let buildInfo = {
    libsite: 'libs.wware.org',
    precss: [],
    prejs: []
  }
  let $content
  let $tplContent
  let html = para.content
  if (typeof html === 'object') {
    let tplStr = ''
    for (var layerName in html) {
      if (layerName === '_wwmain') {
        $content = $(`<div>${dumpGrapeOBJ(html[layerName])}</div>`)
      } else {
        tplStr += `<template name="${layerName}">${dumpGrapeOBJ(html[layerName])}</template>`
      }
    }
    $tplContent = $(`<div>${tplStr}</div>`)
  } else if (typeof html === 'string') {
    $content = $(`<div>${html}</div>`)
    $tplContent = $('<div></div>')
  } else {
    return {
      error: 'invalid params',
      content: '',
      dep: []
    }
  }
  // let $target = $(`<div id="wwcontainer"></div>`)
  // let opts = para.opts || {}
  return Promise.pipe([
    function () { // 检查content中包含的库。深度遍历，从最深层的子节点开始处理。
      // console.log($content)
    },
    function () {
      // 依次调用handlers来处理$content.
      let opt = {
        handlers: handlers,
        idx: 0,
        $content: $content,
        $tplContent: $tplContent,
        buildInfo: buildInfo
      }
      return Promise.whiledo(function (opt) {
        return opt.idx < opt.handlers.length
      }, function (opt) {
        let handler = opt.handlers[opt.idx]
        opt.idx++
        return Promise.pipe([handler(opt), opt])
      }, opt)
      // return outerHtml($target)
    },
    function () {
      // console.log(buildInfo)
      buildInfo.precss = window._.uniq(buildInfo.precss || [])
      buildInfo.prejs = window._.uniq(buildInfo.prejs || [])
      buildInfo.title = buildInfo.title || 'title'
      buildInfo.description = buildInfo.description || ''
      // console.log($content)
      buildInfo.content = outerHtml($content)
      buildInfo.css = para.css || ''
      buildInfo.js = para.js || ''
      buildInfo.tplContent = outerHtml($tplContent)
      buildInfo.ind = {
        bgcolor: '#fff0',
        style: 'working',
        color: '#000',
        text: '',
        imgurl: ''
      }
      return {
        content: window.Template(htmlTPL, buildInfo),
        dep: []
      }
    }
  ])
}

export default build
